import { useState, useEffect, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Box, Typography } from "@mui/material";
import "./styles.css";
import { ru } from "date-fns/locale";
import { CloseIcon } from "../../icons/CloseIcon";
import { CalendarIcon } from "../../icons/CalendarIcons/CalendarIcon";
import { Arrow } from "../../icons/CalendarIcons/Arrow";

const CustomHeader = ({ date, onChange }) => {
  const incrementMonth = () => {
    const newDate = new Date(date);
    newDate.setMonth(date.getMonth() + 1);
    onChange(newDate);
  };

  const decrementMonth = () => {
    const newDate = new Date(date);
    newDate.setMonth(date.getMonth() - 1);
    onChange(newDate);
  };

  const incrementYear = () => {
    const newDate = new Date(date);
    newDate.setFullYear(date.getFullYear() + 1);
    onChange(newDate);
  };

  const decrementYear = () => {
    const newDate = new Date(date);
    newDate.setFullYear(date.getFullYear() - 1);
    onChange(newDate);
  };

  return (
    <div className="custom-header">
      <Box
        className="year-navigation"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 32px",
          marginBottom: "12px",
        }}
      >
        <Box onClick={decrementYear} sx={{ cursor: "pointer" }}>
          <Arrow />
        </Box>
        <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
          {date?.getFullYear()}
        </Typography>
        <Box onClick={incrementYear} sx={{ cursor: "pointer" }}>
          <Arrow />
        </Box>
      </Box>
      <Box
        className="month-navigation"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 32px",
          marginBottom: "12px",
        }}
      >
        <Box onClick={decrementMonth} sx={{ cursor: "pointer" }}>
          <Arrow />
        </Box>

        <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
          {date?.toLocaleString("ru-RU", { month: "long" })}
        </Typography>
        <Box onClick={incrementMonth} sx={{ cursor: "pointer" }}>
          <Arrow />
        </Box>
      </Box>
    </div>
  );
};

const DateRangePickerFilter = ({
  value,
  onChange,
  writeSearchDataToSessionStorage,
  storageValue,
  placeholder,
  isTableHeader,
  name,
  onBlur,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [internalValue, setInternalValue] = useState(value || [null, null]);

  useEffect(() => {
    setInternalValue(value || [null, null]);
  }, [value]);

  const handleChange = (range) => {
    setInternalValue(range);
    if (range[0] && range[1]) {
      onChange(range);
      writeSearchDataToSessionStorage?.(storageValue, range);
    }
  };

  const clearDates = () => {
    setInternalValue([null, null]);
    onChange([null, null]);
    writeSearchDataToSessionStorage?.(storageValue, "");
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center !important" }}>
      <DatePicker
        selectsRange={true}
        startDate={internalValue[0]}
        endDate={internalValue[1]}
        dateFormat="dd.MM.yyyy"
        open={isOpen}
        className={`date-picker-input ${isTableHeader ? "table-picker" : ""}`}
        placeholderText={placeholder}
        onClickOutside={() => setIsOpen(false)}
        onChange={handleChange}
        locale={ru}
        disabledKeyboardNavigation
        portalId="root-portal"
        readOnly
        name={name}
        onBlur={onBlur}
        renderCustomHeader={({ date, changeYear, changeMonth }) => (
          <CustomHeader
            date={date}
            onChange={(newDate) => {
              changeMonth(newDate.getMonth());
              changeYear(newDate.getFullYear());
            }}
          />
        )}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {internalValue[0] != null && internalValue[1] != null && (
          <Box onClick={clearDates} sx={{ cursor: "pointer", height: "13px" }}>
            <CloseIcon />
          </Box>
        )}
        <Box
          onClick={() => setIsOpen(true)}
          sx={{ cursor: "pointer", color: "var(--mainText)", height: "24px", margin: "0 16px" }}
        >
          <CalendarIcon />
        </Box>
      </Box>
    </Box>
  );
};

export default DateRangePickerFilter;
